import { ColumnDef } from '@/components/data-table/DataTable';
import { Tooltip } from '@/components/ui/Tooltip';
import { maskCNPJ, maskPhone } from '@/utils/masks';
import { EditIcon } from 'lucide-react';

interface ClinicColumnsProps {
	onEdit: (clinic: Clinics.Clinic) => void;
}

const ClinicColumns = ({
	onEdit,
}: ClinicColumnsProps): ColumnDef<Clinics.Clinic, keyof Clinics.Clinic>[] => {
	return [
		{
			header: 'Nome',
			accessor: 'name',
			cell: (_, row) => (
				<span className="truncate font-medium text-dark">
					{row.name}
				</span>
			),
		},
		{
			header: 'Status',
			accessor: 'active',
			cell: (value) => (
				<span
					className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
						!value
							? 'bg-red-100 text-red-800'
							: 'bg-green-100 text-green-800'
					}`}
				>
					{value ? 'Ativo' : 'Inativo'}
				</span>
			),
		},
		{
			header: 'CNPJ',
			accessor: 'cnpj',
			cell: (value) => (
				<span className="text-dark">{maskCNPJ(value as string)}</span>
			),
		},
		{
			header: 'Telefone',
			accessor: 'phone_number',
			cell: (value) => (
				<span className="text-dark">{maskPhone(value as string)}</span>
			),
		},
		{
			header: 'Ações',
			accessor: 'id',
			cell: (_, row) => (
				<div className="flex space-x-2">
					<Tooltip
						content="Editar"
						position="top"
						className="bg-gray-50 text-dark"
					>
						<button
							onClick={() => onEdit(row)}
							className="rounded p-2 text-dark hover:bg-gray-200"
						>
							<EditIcon className="h-4 w-4" />
							<span className="sr-only">Editar</span>
						</button>
					</Tooltip>
				</div>
			),
		},
	];
};

export { ClinicColumns };
